import React from "react";
import data from "./data/protegesDataEn";
import "./page-styles/proteges.scss";
import Header from "../components/header/Header";
import AnimatedLine from "../components/animatedLine/AnimatedLine";
import Video from "../components/Video/Video";

// import images
import Climbing2 from "../assets/images/climbing2.jpg";

import Birds from "../assets/images/birds.png";
import Podpopieczny from "../assets/images/podopieczny.jpg";
import Bufetowa from "../assets/images/bufetowa.jpg";
import Spa from "../assets/images/spa.jpg";
import Silownia from "../assets/images/silownia.jpg";
import Mars from "../assets/images/mars.jpg";
import Grzybobranie from "../assets/images/grzybobranie.jpg";
import Franciszkanie from "../assets/images/franciszkanie.jpg";
import Halina from "../assets/images/halina.jpg";
import IMG from "../components/imgtitle/IMGtitle";
import CTA from "../components/CTA/CTA";

// // import videos
import Przystanek from "../assets/videos/przystanek.mp4";
import Ptaki from "../assets/videos/ptaki.mp4";
import Disco from "../assets/videos/disco.mp4";

// import svg
import Dominny from "../assets/SVG/dominny.svg";
import Discoposter from "../assets/SVG/disko.svg";
import PtakiSVG from "../assets/SVG/ptaki.svg";
import Partners from "../components/partners/PartnersEn";

function Proteges() {
  return (
    <main className="proteges page">
      <section className="proteges__landing">
        <img className="proteges__birds" src={Birds} alt="birds" />

        <Header
          cName="proteges__header"
          h1={data.header}
          content={data.landingText}
          accordicon={data.accordiconText}
          en
        />
        <CTA />
      </section>
      <section className="image-grid-wrapper">
        <div className="image-grid-wrapper__column">
          <IMG title="mushroom picking" src={Grzybobranie} />
          <IMG title="at climbing competitions" src={Climbing2} />
          <IMG title="Zbyszek" src={Podpopieczny} />
          <IMG title="at SPA" src={Spa} />
        </div>
        <div className="image-grid-wrapper__column">
          <IMG title="Halina" src={Halina} />
          <IMG title="at the competition for Bufetowa" src={Bufetowa} />
          <IMG title="at gym" src={Silownia} />
          <IMG title="landing on Mars" src={Mars} />
          <IMG title="in the Franciscan week" src={Franciszkanie} />
        </div>
      </section>
      <section>
        <div className="header-wrapper__h1 wrapper">
          <AnimatedLine>
            <>
              Therapy through <h1 className="h1 accent">joy</h1>.
            </>
          </AnimatedLine>
        </div>

        <div className="movies">
          <Video source={Disco} poster={Discoposter} />
          <Video source={Przystanek} poster={Dominny} />
          <Video source={Ptaki} poster={PtakiSVG} />
        </div>
      </section>

      <Partners />
    </main>
  );
}

export default Proteges;
